import { jsx, jsxs } from 'react/jsx-runtime';
import { Checkbox } from '@fabric-app/ui/components/Checkbox/Checkbox';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { useCallback } from 'react';
import { styled } from 'styled-components';

const Container = styled.li.withConfig({
  displayName: "TaskItemComponent__Container",
  componentId: "sc-dfeb47a6-0"
})([
  `position:relative;display:flex;align-items:flex-start;padding-left:0.5em;&[data-checked='true']{p{text-decoration:line-through;}}&[data-checked='false']{p{text-decoration:none;}}`
]);
const CheckboxWrapper = styled.div.withConfig({
  displayName: "TaskItemComponent__CheckboxWrapper",
  componentId: "sc-dfeb47a6-1"
})([
  `position:absolute;top:0.3em;left:-1em;user-select:none !important;button{&::after{position:absolute;content:'';--hitbox-size:12px;top:calc(var(--hitbox-size) / -2);left:calc(var(--hitbox-size) / -2);width:calc(100% + var(--hitbox-size));height:calc(100% + var(--hitbox-size));}}`
]);
const TaskItemComponent = ({ node, editor, updateAttributes }) => {
  const checked = Boolean(node.attrs.checked);
  const handleCheckboxClick = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (!editor.isEditable) return;
    updateAttributes({
      checked: !checked
    });
  }, [
    checked,
    editor.isEditable,
    updateAttributes
  ]);
  return /* @__PURE__ */ jsx(NodeViewWrapper, {
    children: /* @__PURE__ */ jsxs(Container, {
      "data-checked": checked,
      children: [
        /* @__PURE__ */ jsx(CheckboxWrapper, {
          contentEditable: false,
          children: /* @__PURE__ */ jsx(Checkbox.Default, {
            tabIndex: -1,
            checked,
            onClick: handleCheckboxClick
          })
        }),
        /* @__PURE__ */ jsx(NodeViewContent, {
          as: "div"
        })
      ]
    })
  });
};
const TaskItemComponentStatic = ({ checked, innerHTML }) => {
  return /* @__PURE__ */ jsxs(Container, {
    "data-checked": checked,
    children: [
      /* @__PURE__ */ jsx(CheckboxWrapper, {
        contentEditable: false,
        children: /* @__PURE__ */ jsx(Checkbox.Default, {
          tabIndex: -1,
          checked
        })
      }),
      /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: innerHTML
        }
      })
    ]
  });
};

export { TaskItemComponent, TaskItemComponentStatic };
//# sourceMappingURL=TaskItemComponent.js.map
